import Store from "store";

const ROLES = {
  ROLE_USER: "ROLE_USER",
  ROLE_SUPPORTER: "ROLE_SUPPORTER",
  ROLE_ADMIN: "ROLE_ADMIN",
  ROLE_ACCOUNTING: "ROLE_ACCOUNTING",
};

export const checkPermissionsOfRoute = (branchRoute, dispatch, history, authInfo) => {
  const route = branchRoute.route || {};
  const permission = branchRoute.permission || route.permission;
  const permissions = branchRoute.permissions || route.permissions;
  const loginRequired = branchRoute.authenticated || branchRoute.loginRequired || route.authenticated;
  if (!permission && !loginRequired && (!permissions || permissions.length === 0)) {
    return true;
  }
  const configPermissions = [];

  if (permission) {
    configPermissions.push(permission);
  }
  if (permissions && permissions.length > 0) {
    configPermissions.concat(permissions);
  }

  if (window.location.pathname === "/information") return;


  // TODO: handle this on 403 error codes not like this
  if (configPermissions.length > 0 && !isValidPermissions(configPermissions) || (loginRequired && !authInfo.token)) {
    return false;
  }
  return true;
};

export const isValidPermissions = (configPermissions) => {
  if (!configPermissions || configPermissions.length === 0) {
    return true;
  }
  const { user } = Store.getState().user;
  const permissions = user && user.permissions || [user.type.toLowerCase()];

  if (!permissions || permissions.length === 0) {
    return false;
  }

  for (let i = 0; i < permissions.length; i++) {
    for (let j = 0; j < configPermissions.length; j++) {
      if (permissions[i] && permissions[i].toUpperCase() === configPermissions[j].toUpperCase()) {
        return true;
      }
    }
  }

  return false;
};

export default ROLES;
